import styled, { css } from 'styled-components';
import { theme } from '../../../theme';

export const DivWrapper = styled.div<{ isInvalid: number }>`
  width: 100%;

  ${(props) =>
    props.isInvalid &&
    css`
      .control-wrapper {
        > div {
          border-color: ${theme.colors.error};
        }
      }
    `}
`;

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const HiddenStyles = (base) => ({
  ...base,
  display: 'none'
});

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const ShowStyles = (base) => ({
  ...base,
  display: 'flex'
});

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const PlaceholderStyles = (base, state) => ({
  ...base,
  margin: 0,
  color: state.isDisabled ? theme.select.hoverColor : theme.colors.secondary,
  fontWeight: 500
});

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const ControlStyles = (base, state) => {
  const borderColor = state.isDisabled ? theme.select.hoverColor : theme.colors.secondary;

  return {
    ...base,
    minHeight: '3rem',
    padding: '0.308rem 1.078rem',
    borderRadius: 5,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor,
    backgroundColor: theme.colors.white,
    outline: 'none',
    boxShadow: 'none',
    cursor: state.isDisabled ? 'not-allowed' : 'text',
    opacity: state.isDisabled ? '0.6' : '1',
    '&:hover': {
      borderColor
    }
  };
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const ValueContainerStyles = (base, state) => {
  return {
    ...base,
    padding: 0,
    cursor: state.isMulti ? 'default' : 'pointer'
  };
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const MenuStyles = (base) => ({
  ...base,
  marginTop: 2,
  backgroundColor: theme.colors.white,
  boxShadow: theme.shadows.box,
  border: '1px solid rgba(0,0,0,.15)',
  borderRadius: 5,
  zIndex: 2
});

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const InputStyles = (base) => ({
  ...base,
  '& input': {
    fontSize: '0.923rem',
    fontWeight: 500,
    color: theme.colors.textPrimary
  }
});

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const MenuListStyles = (base) => ({
  ...base,
  maxHeight: '200px',
  '&::-webkit-scrollbar': {
    width: 5
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: theme.filters.scrollbarTrack,
    borderRadius: 5
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.colors.secondary,
    borderRadius: 5,
    outline: 'none'
  }
});

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const MultiValueStyles = (base) => ({
  ...base,
  margin: '0.154rem 0.615rem 0.154rem 0',
  padding: '0 0.308rem 0 0.615rem',
  backgroundColor: theme.colors.surfaceFront,
  borderRadius: 5,
  '& > div': {
    padding: 0,
    color: theme.colors.secondary,
    fontWeight: 600,
    lineHeight: '1.846rem'
  },
  '& > div:last-of-type': {
    marginLeft: '0.615rem',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'unset',
      svg: {
        fill: theme.colors.secondaryHover
      }
    }
  }
});

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const DropdownIndicatorStyled = (base, state) => ({
  ...base,
  display: 'flex',
  fontSize: '1.5rem',
  padding: 0,
  cursor: state.isMulti ? 'default' : 'pointer',
  color: state.isDisabled ? theme.select.hoverColor : theme.colors.secondary
});

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const OptionStyled = (base, state) => {
  const isActive = state.isHovered || state.isSelected || state.isFocused || state.isActive;

  return {
    ...base,
    padding: '0.25rem 1.5rem',
    lineHeight: '2.307rem',
    backgroundColor: (isActive ? theme.select.hoverBackground : theme.colors.white) + '!important',
    color: isActive ? theme.select.hoverColor : theme.colors.textPrimary,
    fontSize: '0.923rem',
    fontWeight: 500,
    whiteSpace: 'pre-line',
    cursor: 'pointer'
  };
};
